import React, { useEffect, useState } from 'react';
import {
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  IconButton,
  Tooltip,
  TablePagination,
  Button,
  Checkbox
} from '@mui/material';
import DeleteIcon from '@mui/icons-material/Delete';
import Swal from 'sweetalert2';
import { Await, useNavigate } from 'react-router-dom';
import Loading from '../Loading';
import api from '../../utils/functions/api'; // Import API functions
import { swalConfirm, swalErrorBtn, swalErrorTimer, swalSuccessBtn } from '../../helpers/swalHelper';
import CompanyListApi from '../../service/company.api';
import LinearLoading from '../LinearLoading';

export default function TableCompanyList({ companyList, getCompanyList, isLinearLoading }) {
  const [isLoading, setIsLoading] = useState(false);
  const [rows, setRows] = useState([]);
  const [filteredRows, setFilteredRows] = useState([]);
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(5);
  const navigate = useNavigate();

  useEffect(() => {
    setRows(companyList);
    setFilteredRows(companyList);
  }, [companyList]);

  const handleDeleteRow = async (_id) => {
    try {
      const result = await swalConfirm({title: 'ยืนยันการลบรายการ?', icon: 'warning'});

      if (result.isConfirmed) {
        // const updatedRows = rows.filter((row) => row.tax_id !== tax_id);
        // setRows(updatedRows);
        // setFilteredRows(updatedRows);
        await deleteCompany(_id);
        swalSuccessBtn({title: 'ลบรายการสำเร็จ'});
        await getCompanyList()
      } else if (result.isDenied) {
        swalErrorBtn({title: 'ยกเลิกการลบรายการ'});
      }
    } catch (error) {
      console.log(error);
      swalErrorTimer({text: 'ลบรายการไม่สำเร็จ'});
    }
  };

  const deleteCompany = async (_id) => {
    try {
      const response = await CompanyListApi.deleteCompanyApi(_id);
      if (response.code !== 200) {
        throw new Error(response.message);
      }
    } catch (error) {
      throw new Error('Error deleting company:', error);
    }
  };

  const handleManageCompany = (row) => {
    navigate('/company-management', {
      state: {
        _id:row._id,
        tax_id: row.tax_id,
        status_etax: row.status_etax,
      },
    });
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setPage(0);
  };

  return (
    <div>
      <Loading isLoading={isLoading} />
      <div className="px-2 mt-6">
        <TableContainer sx={{ overflowX: 'auto' }} component={Paper}>
          { <LinearLoading isLinearLoading={isLinearLoading} /> }
          <Table stickyHeader aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell align="left" width={'15%'}> เลขประจำตัวผู้เสียภาษี</TableCell>
                <TableCell align="left" width={'15%'}>ชื่อบริษัท</TableCell>
                <TableCell align="left" width={'15%'}>Email</TableCell>
                {/* <TableCell align="center">Key Ops</TableCell> */}
                <TableCell align="center" width={'15%'}>status e-tax</TableCell>
                <TableCell align="center" width={'15%'}>การจัดการร้านค้า</TableCell>
                <TableCell align="center" width={'10%'}>ลบรายการ</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {filteredRows
                .slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                .map((row) => (
                  <TableRow key={row._id}>
                    <TableCell align="left">{row.tax_id || '-'}</TableCell>
                    <TableCell align="left">{row.name || '-'}</TableCell>
                    <TableCell align="left">{row.company_Email || '-'}</TableCell>
                    {/* <TableCell align="center">{row.key_ops}</TableCell> */}
                    <TableCell align="center">
                      <Checkbox
                        checked={row.status_etax} // true or false
                        disabled // This makes the checkbox read-only
                      />
                    </TableCell>
                    <TableCell align="center">
                      <Button
                        sx={{ color: '#fff', Width: 'fit-content' }}
                        variant="contained"
                        onClick={() => handleManageCompany(row)}
                      >
                        จัดการร้านค้า
                      </Button>
                    </TableCell>
                    <TableCell align="center">
                      <Tooltip title="ลบรายการ" arrow>
                        <IconButton onClick={() => handleDeleteRow(row._id)}>
                          <DeleteIcon color="error" />
                        </IconButton>
                      </Tooltip>
                    </TableCell>
                  </TableRow>
                ))}
            </TableBody>
          </Table>
          <TablePagination
            rowsPerPageOptions={[5, 10, 25, 50]}
            component="div"
            count={filteredRows.length}
            rowsPerPage={rowsPerPage}
            page={page}
            onPageChange={handleChangePage}
            onRowsPerPageChange={handleChangeRowsPerPage}
          />
        </TableContainer>
      </div>
    </div>
  );
}
